<template>
  <div class="rounded border border-gray-400 bg-white divide-y overflow-hidden">
    <div
      v-if="title"
      class="flex p-4 space-x-4 cursor-pointer hover:bg-gray-100"
      @click="expanded = !expanded"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-6 h-6 text-gray-600"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path v-if="expanded" d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z" />
        <path v-else d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
      </svg>
      <h3 class="text-base font-medium uppercase">
        {{ title }}
      </h3>
    </div>
    <template v-if="expanded">
      <!-- <div
        class="flex items-center p-4"
      >
        //
      </div> -->
      <div class="grid grid-cols-4 gap-4 p-4 items-stretch">
        <AssetTile
          v-for="asset in assets"
          :key="asset.id"
          :asset="asset"
          :selected-asset-ids.sync="localSelectedAssetIds"
          :without-actions="withoutActions"
          @view-note="$emit('view-note', $event)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import AssetTile from './AssetTile.vue';

export default {
  name: 'AssetGroup',
  components: {
    AssetTile,
  },
  props: {
    withoutActions: Boolean,
    title: {
      type: String,
      default: '',
    },
    assets: {
      type: Array,
      default: () => [],
    },
    selectedAssetIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: true,
    };
  },
  computed: {
    localSelectedAssetIds: {
      get() {
        return this.selectedAssetIds;
      },
      set(value) {
        this.$emit('update:selected-asset-ids', value);
      },
    },
  },
  methods: {
    //
  },
};
</script>
